import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/qmdash-logo-new.png")